import type { Selection } from '../types';

export type SelectionChipLevel = 'group' | 'row' | 'column' | 'block';

export function selectionChipLevel(
  selection: Selection,
): SelectionChipLevel | null {
  switch (selection.kind) {
    case 'group':
      return 'group';
    case 'row':
      return 'row';
    case 'column':
      return 'column';
    case 'block':
    case 'buttonRowSlot':
      return 'block';
    default:
      return null;
  }
}
